var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.495 2.5L0.499 2.5 0.499 23.5 23.472 23.5 23.472 2.5 19.477 2.5",
    transform: "translate(-289 -418) translate(249 389) translate(27 16) translate(13.153 13) translate(.999 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.495 4.5L7.491 4.5 7.491.5 4.495.5zM16.48 4.5L19.477 4.5 19.477.5 16.48.5zM7.491 2.5L16.48 2.5M.499 7.5L23.472 7.5M7.99 9.5L7.99 21.5M14.982 9.5L14.982 21.5M2.497 13L21.474 13M2.497 18L21.474 18",
    transform: "translate(-289 -418) translate(249 389) translate(27 16) translate(13.153 13) translate(.999 1)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e1fc0167.svg";
export { ForwardRef as ReactComponent };